import React, { useContext } from 'react';
import { ThemeContext } from '../../hooks/ThemeContext';
import { Link } from 'react-router-dom';

const CTABox = ({ 
  title, 
  description, 
  buttonText = 'En savoir plus', 
  buttonLink = '/contact',
  variant = 'default' 
}) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === 'dark';

  const variants = {
    default: isDark 
      ? 'bg-gradient-to-br from-rose-500/20 to-purple-500/20 border border-white/10' 
      : 'bg-gradient-to-br from-rose-50 to-purple-50 border border-gray-200',
    primary: isDark 
      ? 'bg-gradient-to-br from-rose-500 to-rose-600' 
      : 'bg-gradient-to-br from-rose-600 to-rose-700',
  };

  const textColor = variant === 'primary' ? 'text-white' : '';

  return (
    <div className={`${variants[variant]} ${textColor} rounded-lg p-8 text-center`}>
      <h3 className="text-2xl md:text-3xl font-bold mb-3">{title}</h3>
      <p className={`text-lg mb-6 ${variant === 'primary' ? 'opacity-90' : isDark ? 'text-white/80' : 'text-gray-700'}`}>
        {description}
      </p>
      <Link
        to={buttonLink}
        className={`inline-block px-6 py-3 rounded font-medium transition-all ${
          variant === 'primary'
            ? isDark
              ? 'bg-white text-rose-600 hover:bg-gray-100'
              : 'bg-white text-rose-700 hover:bg-gray-50'
            : isDark
            ? 'bg-rose-500 text-white hover:bg-rose-600'
            : 'bg-rose-600 text-white hover:bg-rose-700'
        }`}
      >
        {buttonText}
      </Link>
    </div>
  );
};

export default CTABox;
